var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _NotificationState_instances, _NotificationState_onStateChange, _NotificationState_state, _NotificationState_updateState;
export class NotificationState {
    constructor(onStateChange) {
        _NotificationState_instances.add(this);
        _NotificationState_onStateChange.set(this, void 0);
        _NotificationState_state.set(this, {
            notifications: new Map(),
        });
        this.addMessageBatch = (batch) => {
            if (!batch.length) {
                return;
            }
            const notifications = new Map(__classPrivateFieldGet(this, _NotificationState_state, "f").notifications);
            batch.forEach((notification) => {
                notifications.set(notification.timetoken.toString(), notification);
            });
            __classPrivateFieldGet(this, _NotificationState_instances, "m", _NotificationState_updateState).call(this, notifications);
        };
        this.clear = () => {
            __classPrivateFieldGet(this, _NotificationState_instances, "m", _NotificationState_updateState).call(this, new Map());
        };
        __classPrivateFieldSet(this, _NotificationState_onStateChange, onStateChange, "f");
    }
    get state() {
        return __classPrivateFieldGet(this, _NotificationState_state, "f");
    }
}
_NotificationState_onStateChange = new WeakMap(), _NotificationState_state = new WeakMap(), _NotificationState_instances = new WeakSet(), _NotificationState_updateState = function _NotificationState_updateState(newNotifications) {
    __classPrivateFieldSet(this, _NotificationState_state, {
        notifications: newNotifications,
    }, "f");
    __classPrivateFieldGet(this, _NotificationState_onStateChange, "f").call(this, __classPrivateFieldGet(this, _NotificationState_state, "f"));
};
